import { Reducer } from "redux";

import { ApplicationTheme } from "@multiweb/uiShared/ApplicationTheme";
import { ISetThemeAction, ThemeState } from "./types";

export const theme: Reducer<ApplicationTheme> = (state = ApplicationTheme.light, action) => {
    if (action instanceof ISetThemeAction) {
        return action.payload.theme;
    } else {
        return state;
    }
};

export const reducer: Reducer<ThemeState> = theme;
